module.exports = __webpack_public_path__ + "img/las_vegas_2.db48188c.jpg";